import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import app from '@/config/firebase'

/**
 * Instance Functions partagée.
 *
 * La région doit rester alignée sur `functions/src/config.js`, sinon les appels
 * `httpsCallable` ne trouvent pas les fonctions déployées.
 */
export const FUNCTIONS_REGION = 'europe-west1'

const functions = getFunctions(app, FUNCTIONS_REGION)

// En développement local, on se branche sur l'émulateur s'il est démarré.
if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && process.env.VUE_APP_USE_EMULATOR === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

export default functions
